import React from 'react';
import { accent } from '../utils/colors';

export default function PlanLearningModal({
  isOpen,
  onClose,
  onSubmit,
  loading = false,
  apiError = null
}) {
  const [value, setValue] = React.useState('');
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    if (isOpen) {
      setValue('');
      setError('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const raw = e.target.value;
    const digitsOnly = raw.replace(/\D+/g, '');
    setValue(digitsOnly);
    if (digitsOnly && /^0+$/.test(digitsOnly)) {
      setError('Id не может состоять только из нулей');
    } else {
      setError('');
    }
  };

  const handleSubmit = () => {
    if (!value) {
      setError('Укажите Id из CRM');
      return;
    }
    const parsed = parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed <= 0) {
      setError('Некорректный Id');
      return;
    }
    onSubmit?.(parsed);
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: '#fff',
        padding: 20,
        borderRadius: 12,
        width: '90%',
        maxWidth: 380,
        boxShadow: '0 4px 24px #00000022'
      }}>
        <h3 style={{ margin: 0, marginBottom: 12, color: accent }}>Запланировать изучение</h3>
        <div style={{ fontSize: 14, color: '#555', marginBottom: 8, textAlign: 'center' }}>Укажите Id дела из CRM</div>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 4 }}>
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder="Например, 123456"
            value={value}
            onChange={handleChange}
            onKeyDown={(e) => { if (e.key === 'Enter' && !loading) handleSubmit(); }}
            disabled={loading}
            style={{
              width: '100%',
              fontSize: 16,
              borderRadius: 6,
              border: `1.5px solid ${error ? '#dc3545' : accent}`,
              padding: 8,
              outline: 'none',
              opacity: loading ? 0.6 : 1,
              cursor: loading ? 'not-allowed' : 'text'
            }}
          />
        </div>
        {error ? (
          <div style={{ color: '#dc3545', fontSize: 13, marginTop: 6, textAlign: 'center' }}>{error}</div>
        ) : null}
        {apiError ? (
          <div style={{ color: '#dc3545', fontSize: 13, marginTop: 6, textAlign: 'center' }}>{apiError}</div>
        ) : null}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 14 }}>
          <button
            onClick={onClose}
            disabled={loading}
            style={{
              background: '#6c757d',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '8px 14px',
              fontSize: 14,
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              marginRight: 8,
              opacity: loading ? 0.6 : 1
            }}
          >
            Отмена
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              background: accent,
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '8px 14px',
              fontSize: 14,
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1
            }}
          >
            {loading ? 'Сохранение...' : 'Сохранить'}
          </button>
        </div>
      </div>
    </div>
  );
}


